
const propertiesResetJSON = {
    "frame": {
        BackColor: "",
        FontColor: "",
        FontFamily: "",
        FontSize: "",
        FontWeight: "",
        SectionBackColor: "",
        ControlStyle: "",
        BorderColor: "",
        BorderRadius: "",
        BorderWidth: ""
    },

    'textbox': {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "BorderColor": "",
        "BackColor": "",
        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
        "LabelRatio": ""
    },
    'password': {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "BorderColor": "",
        "BackColor": "",
        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
        "LabelRatio": ""
    },
    'textarea': {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "BorderColor": "",
        "BackColor": "",
        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
        "LabelRatio": ""
    },
    'datepick': {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "LabelRatio": "",
        "BorderColor": "",
        "BackColor": "",
        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
        "DateFormat": ""
    },
    "radio": {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "BorderColor": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
    },
    'slider': {
        "ActiveSliderBar": "",        
        "FontWeightKey": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "FontColorSlider": "",
    },
    
    'button': {        
        "ButtonType": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontFamily": "",
        "BorderColor": "",
        "BorderWidth": "",
        "FontColor": "",
        "CornerRadius": "",
        "BackgroundColor": ""
    },


    'tab': {
        "ActiveTabFontFamily" : "",
        "ActiveTabFontSize" : "",
        "ActiveTabFontWeight" : "",
        "ActiveTabFontColor" : "", 
        "ActiveTabBackColor" : "",
        "ActiveTabCornerRadius" : "",
        "InActiveTabFontFamily" : "",
        "InActiveTabFontSize" : "",
        "InActiveTabFontWeight" : "",
        "InActiveTabFontColor" : "", 
        "InActiveTabBackColor" : "",
        "TabBackgroundColor": "",
        "BorderColor" : "",
        "BorderWidth" : "",
        "BorderRadius" : "",
        "ControlStyle": "",
    },

    'picklist': {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "LabelRatio": "",
        "BorderColor": "",

        "BackColor": "",

        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",

        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
    },
    'checkbox': {
        "ControlStyle": "",
        "ActiveStateColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "LabelWeight": "",
        "FontStyle": "",
        "FontColor": "",
    },
    'table': {
        "ControlStyle": "",
        "ListviewTitleFontFamily": "",
        "ListviewTitleFontWeightStyle": "",

        "ListviewTitleFontWeight": "",
        "ListviewTitleFontStyle": "",
        "ListviewTitleFontSize": "",
        "ListviewTitleFontColor": "",

        "TableHeaderHeight": "",
        "TableHeaderFontFamily": "",
        "TableHeaderFontWeightStyle": "",
        "TableHeaderFontWeight": "",
        "TableHeaderFontStyle": "",
        "TableHeaderFontSize": "",
        "TableHeaderTextAlignment": "",
        "TableHeaderBackgroundColor": "",

        "TableHeaderFontColor": "",

    },

    'listview': {
        "BackgroundColor": "",

        "ControlStyle": "",
        "FontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontStyle": "",
        "FontWeight": "",
        "HoverEffect": "",
        "ListviewTitleFontColor": "",
        "ListviewTitleFontFamily": "",
        "ListviewTitleFontSize": "",
        "ListviewTitleFontStyle": "",
        "ListviewTitleFontWeight": "",
        "ListviewTitleFontWeightStyle": "",
        "TableHeaderBackgroundColor": "",
        "TableHeaderFontColor": "",
        "TableHeaderFontFamily": "",

        "TableHeaderFontSize": "",
        "TableHeaderFontStyle": "",
        "TableHeaderFontWeight": "",
        "TableHeaderFontWeightStyle": "",
        "TableHeaderTextAlignment": "",
        "TableSelectedRowColor": "",
        "TextAlignment": "",
    },

    'advancelistview': {
        "BackgroundColor": "",
        "ControlStyle": "",
        "FontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontStyle": "",
        "FontWeight": "",
        "HoverEffect": "",
        "ListviewTitleFontColor": "",
        "ListviewTitleFontFamily": "",
        "ListviewTitleFontSize": "",
        "ListviewTitleFontStyle": "",
        "ListviewTitleFontWeight": "",
        "ListviewTitleFontWeightStyle": "",
        "TableHeaderBackgroundColor": "",
        "TableHeaderFontColor": "",
        "TableHeaderFontFamily": "",
        "TableHeaderFontSize": "",
        "TableHeaderFontStyle": "",
        "TableHeaderFontWeight": "",
        "TableHeaderFontWeightStyle": "",
        "TableHeaderTextAlignment": "",
        "TableSelectedRowColor": "",
        "TextAlignment": "",
    },
    "listbox": {
        "ControlStyle": "",
        "LabelInputAlignment": "",
        "LabelRatio": "",
        "BorderColor": "",
        "BackColor": "",
        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
    },

    "combo": {
        "ControlStyle": "",
        "LabelInputAlignment": "",

        "BorderColor": "",
        "BackColor": "",
        "BorderWidth": "",
        "BorderRadius": "",
        "LabelFontFamily": "",
        "LabelFontSize": "",
        "LabelFontWeight": "",
        "LabelFontStyle": "",
        "LabelWeightStyle": "",
        "LabelFontColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
    },

    "image": {
        "FontFamily": "",
        "FontSize": ""
    },
    "captcha": {
        "FontFamily": "",
        "FontSize": ""
    },

    'label': {
        "TextAlignment": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "FontStyle": "",
        "WeightStyle": "",
        "FontColor": "",
        "BackColor": "",
    },
    'link': {
        "FontFamily": "",
        "FontSize": ""
    },
    'toggle': {
        "ToggleStyle": "",
        "LabelSwitchAlignment": "",

        "ActiveStateBackgroundColor": "",
        "FontFamily": "",
        "FontSize": "",
        "FontWeight": "",
        "Color": "",
    },
    'richtexteditor': {
        "FontFamily": "",
        "FontSize": ""
    },
    "wizard_h":{
        ActiveBackgroundColor:"#0072c6",        
        backgroundColor:"#F8F8F8"
    },
    "wizard_v":{
        ActiveBackgroundColor:"#0072c6",        
        backgroundColor:"#F8F8F8"
    },
    "doclist": {
        "DocumentListLabelFontFamily": "",
        "DocumentListLabelFontWeight": "",
        "DocumentListLabelFontStyle": "",
        "DocumentListLabelFontWeightStyle": "",
        "DocumentListLabelFontSize": "",
        "DocumentListLabelFontColor": "",
        "DocumentTypeLabelFontFamily": "",

        "DocumentTypeLabelFontWeight": "",

        "DocumentTypeLabelFontStyle": "",

        "DocumentTypeLabelFontWeightStyle": "",

        "DocumentTypeLabelFontSize": "",
        "DocumentTypeLabelFontColor": "",

    },
    "tile":{
        TileBackgroundColor:""
    },
    "form": {
        pageBackgroundColor:""
    }
}

export { propertiesResetJSON };